<template>
  <div class="page" id="not-found">
    <Metadata
      :title="this.title"
    />
    <div class="not-found-container">
      <div class="not-found-heading">404</div>
      <div class="not-found-subheading">Not found</div>
      <div class="not-found-message">Our apologies! The page you're visiting doesn't exist</div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Bottom from '../components/nav/Bottom.vue';

export default {
  name: 'NotFound',
  components: {
    Bottom,
  },
  data() {
    return {
      title: `Not Found`,
    };
  },
};
</script>

<style>

.not-found-container {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 10%;
}

.not-found-heading {
  font-family: 'Libre Baskerville', serif;
  font-size: 208px;
  color: #ccc;
}

.not-found-subheading {
  font-family: 'Libre Baskerville-Regular', serif;
  font-size: 44px;
  color: #4c123e;
  margin-top: -35px;
}

.not-found-message {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 18px;
  color: #222;
  margin-top: 21px;
}
</style>
